import { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { DefaultLoader } from 'components/Loaders/DefaultLoader';
import { useShopManager } from 'hooks/useShopManager';
import { useBodyClassName } from 'hooks/useBodyClassName';
import { useIsNewDesign } from 'hooks/useIsNewDesign';

const ShopRouter = lazy(() => import('modules/ScrShop'));
const PhotobookRouter = lazy(() => import('modules/ScrPhotobook'));
const ShopNewRouter = lazy(() => import('modules/ScrShopNew'));
const PortfolioRouter = lazy(() => import('modules/ScrPortfolio'));
const ScrappbookLegacyRouter = lazy(() => import('modules/ScrAppBook'));
const ScrappbookNewRouter = lazy(() => import('modules/ScrAppBookNew'));

export const AppModules: React.FC = () => {
  const isNewDesign = useIsNewDesign();
  useShopManager();
  useBodyClassName();

  const ScrappbookAppRouter = isNewDesign ? ScrappbookNewRouter : ScrappbookLegacyRouter;

  return (
    <Suspense fallback={<DefaultLoader />}>
      <Switch>
        <Route path="/shop-new" component={ShopNewRouter} />
        <Route path="/shop" component={ShopRouter} />
        <Route path="/photobook" component={PhotobookRouter} />
        <Route path="/p/:id" component={PortfolioRouter} />
        <Route
          key={isNewDesign ? 'new-design' : 'legacy-design'}
          path="*"
          component={ScrappbookAppRouter}
        />
      </Switch>
    </Suspense>
  );
};
